import React, { useState, useEffect, useRef } from "react";
import DatePicker from 'react-datepicker';
import axios from "axios";
import './CMRRoasterEntry.css';
import { jsPDF } from "jspdf";  // Import jsPDF
import "jspdf-autotable";
import pds from './pds.PNG';
import Select from 'react-select'; // Import react-select
import { format } from 'date-fns';
import ExcelJS from 'exceljs';
import { use } from "react";
import { useNavigate } from 'react-router-dom';

const customStyles = {
    control: (provided) => ({
        ...provided,
        borderRadius: "4px",
        padding: "2px",

    }),
    dropdownIndicator: (provided) => ({
        ...provided,

        cursor: "pointer", // Change cursor to indicate it's clickable
    }),
    indicatorSeparator: () => ({
        display: "none", // Hide the default separator

    }),
};

const CMRRoasterEntry = () => {
    const navigate = useNavigate();
    const [allocationType, setAllocationType] = useState('1'); // '1' = CMR by default


    const [isValidSelection, setIsValidSelection] = useState(false);  // Add this state
    const [godownData, setGodownData] = useState([]); // Store the FPS data from API
    //const [selectedId, setSelectedId] = useState(null); // Selected FPS ID
    // const [selectedRows, setSelectedRows] = useState([]); // Track selected rows (by id or godownId)
    //  const [godownData, setGodownData] = useState([]); // Initial state is an empty array
    const [selectedRows, setSelectedRows] = useState([]); // Initially empty
    const [selectAll, setSelectAll] = useState(false); // Initially unchecked
    const [selectedId, setSelectedId] = useState(null);
    const [fpsUniqueId, setFpsUniqueId] = useState("");
    const [godownId, setgodownId] = useState("");
    const [fpshops, setFPShops] = useState([]);
    const [districtUid, setDistrictUid] = useState(''); // Store districtUid for reports
    const [subDivisionUid, setSubDivisionUid] = useState(''); // Store subdistrictUid for reports
    const [blockUid, setBlockUid] = useState(' ');
    const [panchayatUid, setPanchayatUid] = useState(' ');
    const [showTable, setShowTable] = useState(false);
    //  const [reportData, setReportData] = useState([]);
    const [districtId, setDistrictId] = useState("");
    const [subDivisionId, setSubDivisionId] = useState('');
    const [blockId, setBlockId] = useState('');
    const [districts, setDistricts] = useState([]);
    const [subDivisions, setSubDivisions] = useState([]);
    const [blocks, setBlocks] = useState([]);
    const [panchayatId, setPanchayatId] = useState("");
    const [panchayats, setPanchayats] = useState([]);
    // const [godownId, setgodownId] = useState("");  // Ensure this is defined at the top of your component
    const [inspectionOfficerId, setInspectionOfficerId] = useState(null);
    const [inspectionOfficers, setInspectionOfficers] = useState([]);
    const [username, setUserName] = useState('');
    const [poimsUserId, setId] = useState('');
    const [officerDesignation, setOfficerDesignation] = useState('');
    const [designationName, setDesignationName] = useState('');
    const [error, setError] = useState(null);  // Define setError here


    //const [showDownloadPdf, setShowDownloadPdf] = useState(false);
    // const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    // const [showCalendar, setShowCalendar] = useState(false);
    const [showEndCalendar, setShowEndCalendar] = useState(false);
    const [showDownloadButton, setShowDownloadButton] = useState(false);
    const [stockData, setStockData] = useState([]);
    const today = new Date();
    //const formattedToday = today.toISOString().split('T')[0]; // Format as 'YYYY-MM-DD'
    const startOfYear = new Date(today.getFullYear(), 0, 1); // January 1st of the current year
    const formattedStartOfYear = startOfYear.toISOString().split('T')[0]; // Format as 'YYYY-MM-DD'

    const reportRef = useRef(null);  // Reference to the report HTML
    const [isOpen, setIsOpen] = useState(false); // To control dropdown open/close
    // Get the current date and reset time to midnight to avoid time-based issues
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Reset time to midnight
    // Determine the minimum date for the endDate date picker
    const currentYear = currentDate.getFullYear();
    const minStartDate = new Date(currentYear, 0, 1);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userInfo, setUserInfo] = useState({
        // displayName: '',
        // empId: ''
        fullName: '',
        employeeId: '',
        id: '',
        username: '',
    });
    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('user'));
        const loginTime = localStorage.getItem('loginTime');

        if (userData) {
            // Extract the first name from fullName (only the first word)
            const firstName = userData.fullName.split(' ')[0];

            // Set the state with firstName and employeeId
            setUserInfo({
                fullName: firstName,  // Only first name is considered
                employeeId: userData.employeeId,
                id: userData.id,
                loginUserName: userData.username,
            });
            setIsLoggedIn(true);
            // setLastLoginDateTime(`Last Login: ${format(new Date(loginTime), 'dd-MM-yyyy | hh:mm:ss a')}`);
        } else {
            setIsLoggedIn(false);
        }
    }, []);


    const handleStartDateChange = (e, godownId) => {
        const newDate = e.target.value;
        // Update the `startDate` for the specific row
        setGodownData(godownData.map(item =>
            item.godownId === godownId ? { ...item, startDate: newDate } : item
        ));
        // Check if any row has both date and checkbox selected
        // checkValidSelection();
    };


    const token = `${process.env.REACT_APP_AFTER_TOKEN}`;
    //const baseUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api`;
    const baseUrl = `${process.env.REACT_APP_AUDIT_API_URL}/api`;  // Define the base URL
    const godownUrl = `${process.env.REACT_APP_GODOWN_API_URL}/api`;  // Define the base URL
    useEffect(() => {
        //  console.log('Token:', token);  // Check if token is set
        if (token) {
            axios
                .get(`${baseUrl}/districts?pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },

                })
                .then((response) => {
                    if (response.data && response.data.data && Array.isArray(response.data.data)) {

                        setDistricts(response.data.data);

                    }
                })
                .catch((error) => {
                    setError("Error fetching districts");
                    console.error("Error fetching districts:", error);
                });
        } else {
            setError("No token found. Please log in.");
        }
    }, [token]);
    const fetchSubDivisions = async (districtId) => {
        if (districtId) {
            try {
                const response = await axios.get(`${baseUrl}/sub-divisions?filters[district][id][$eq]=${districtId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setSubDivisions(response.data.data || []);
            } catch (error) {
                setError("Error fetching sub-divisions");
            }
        } else {
            setSubDivisions([]);
        }
    };

    const fetchBlocks = async (subDivisionId) => {
        if (subDivisionId) {
            try {
                const response = await axios.get(`${baseUrl}/blocks?filters[subDivision][id][$eq]=${subDivisionId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setBlocks(response.data.data || []);
            } catch (error) {
                setError("Error fetching blocks");
            }
        } else {
            setBlocks([]);
        }
    };

    const fetchPanchayats = async (blockId) => {
        if (blockId) {
            try {
                const response = await axios.get(`${baseUrl}/panchayats?filters[block][id][$eq]=${blockId}&pagination[pageSize]=50`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setPanchayats(response.data.data || []);
            } catch (error) {
                setError("Error fetching panchayats");
            }
        } else {
            setPanchayats([]);
        }
    };



    useEffect(() => {
        if (token && districtId) {
            fetchInspectionOfficersAll();
        } else {
            setError("No token found. Please log in.");
        }
    }, [districtId]); // This effect runs only once when the component mounts

    // Fetch all inspection officers
    const fetchInspectionOfficersAll = async () => {
        try {
            // Make the API call with Authorization header
            const userResponse = await axios.get(`${baseUrl}/users/get-all`, {
                headers: {
                    Authorization: `Bearer ${token}`  // Include Bearer token in the headers
                }
            });

            // Process the response and store the user data in state
            const userData = userResponse.data.data || [];
            setInspectionOfficers(userData);
            setOfficerDesignation(userData);

        } catch (userError) {
            console.error('Error fetching users:', userError);
            setError("Error fetching users.");
        }
    };






    const handleFpsSelection = (selectedgodownId) => {
        setgodownId(selectedgodownId); // Store the selected FPS ID
    };

    const handleInspectionOfficerChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectedOfficer = inspectionOfficers.find((officer) => officer.id === selectedId);
        const selectedlabelfullname = selectedOption ? selectedOption.fullName : '';
        const selectedOfficerUsername = selectedOption ? selectedOption.username : "";
        // Update the selected inspection officer id

        setInspectionOfficerId(selectedId);
        setUserName(selectedOfficerUsername);
        setId(selectedOfficer ? selectedOfficer.id : '');
        setDesignationName(''); // Reset designation when officer changes

        const officerDesignations = inspectionOfficers.filter(officer => officer.id === selectedId);

        // If only one designation exists, set it automatically
        if (officerDesignations.length === 1) {
            setOfficerDesignation(officerDesignations);
            setDesignationName(officerDesignations[0].designation); // Automatically set the designation
        } else {
            // If multiple designations exist, leave it empty for user to select
            setOfficerDesignation(officerDesignations);
        }
    };

    const handleDistrictChange = (selectedOption) => {
        const selectedDistrictId = selectedOption ? selectedOption.value : '';  // districtId for filtering
        const selectedDistrictUid = selectedOption ? selectedOption.districtUid : '';  // districtUid for reports
        setDistrictId(selectedDistrictId);  // For filtering
        setDistrictUid(selectedDistrictUid);  // For report generation
        setSubDivisionUid('');  // Clear subDivisionUid
        setPanchayatUid('');  // Clear panchayatUid
        setBlockUid('');
        setSubDivisionId('');  // Reset sub-division
        setBlockId('');  // Reset block
        setPanchayatId('');  // Reset panchayat
        setPanchayats([])
        setBlocks([])
        setInspectionOfficerId(''); // Clear the inspection officer ID
        setId(''); // Clear poimsUserId
        setShowTable(false);
        setInspectionOfficerId('');
        setDesignationName('');
        fetchSubDivisions(selectedDistrictId);  // Fetch subdivisions based on the selected district

    };

    const handleSubDivisionChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectdSubDivisionUid = selectedOption ? selectedOption.subDivisionUid : "";
        setSubDivisionUid(selectdSubDivisionUid);
        setPanchayatUid('');  // Clear panchayatUid
        setBlockUid('');
        setSubDivisionId(selectedId);
        setBlockId('');  // Reset block
        setPanchayatId('');  // Reset panchayat
        //  setgodownId('');  // Reset FPS ID
        //setFPShops([]);  // Clear FPS shops 
        setPanchayats([]);  //it is not actved panchayats without selecting
        setBlocks([]); //it is not actved block  without selecting
        //   setInspectionDates([])
        //   setInspectionDate('')
        setInspectionOfficerId(''); // Clear the inspection officer ID
        setId(''); // Clear poimsUserId
        // setInspectionOfficerId('');
        setDesignationName('');
        setShowTable(false);
        fetchBlocks(selectedId);  // Fetch blocks based on the selected subdivision


    };

    const handleBlockChange = (selectedOption) => {
        const selectedId = selectedOption ? selectedOption.value : '';
        const selectedBlockUid = selectedOption ? selectedOption.blockUid : '';
        setBlockId(selectedId);
        setBlockUid(selectedBlockUid);
        setPanchayatId('');  // Reset panchayat
        setPanchayats([]);  //it is not actved panchayats  without selecting
        setInspectionOfficerId('');
        setShowTable(false);
        setDesignationName('');
        setInspectionOfficerId(''); // Clear the inspection officer ID
        setId(''); // Clear poimsUserId
        fetchPanchayats(selectedId);
    };

    const handlePanchayatChange = (selectedOption) => {

        const selectedId = selectedOption ? selectedOption.value : '';
        const selectedpanchayatUid = selectedOption ? selectedOption.panchayatUid : '';
        setPanchayatUid(selectedpanchayatUid);
        setPanchayatId(selectedId);
        setId('');
        setDesignationName('');
        setInspectionOfficerId('');
        setgodownId('');
        setFPShops([]);
        setShowTable(false);
    };
    const handlegodownId = (selectedOption) => {
        const selectedgodownId = selectedOption ? selectedOption.value : '';
        const selectedFpsUniqueId = selectedOption ? selectedOption.label : '';
        setgodownId(selectedgodownId);  // Save the selected FPS ID
        setFpsUniqueId(selectedFpsUniqueId);  // Save the selected FPS Unique ID
        //setFpsUniqueId('');
        // setgodownId('');  
        setShowTable(false);  // Show the table after FPS ID is selected
    };
    const toggleDropdown = () => {
        setIsOpen((prevState) => !prevState);
    };
    // Handle change in selected FPS from dropdown
    const handleSelectChange = (selectedOption) => {
        setSelectedId(selectedOption ? selectedOption.value : null);
    };

    const handleGetButtonClick = async () => {
        const requestData = {
            district: districtUid,
            // subDivision: subDivisionUid,
            // block: blockUid,
            // panchayat: panchayatUid,
             surveyType:"1"
        };

        try {
            const response = await axios.post(
                `${godownUrl}/get-godown-by-filters`,
                requestData,
                {
                    headers: { Authorization: `Bearer ${token}` },  // Include the Authorization header here
                }
            );
            // Reset the startDate for all fetched FPS data
            const resetGodownData = response.data.data.map(item => ({
                ...item,
                startDate: "",  // Reset the "Date of Inspection" field for each FPS
            }));
            setGodownData(resetGodownData); // Store FPS data returned from API
            setSelectedRows([]);
            setSelectAll(false); // Uncheck "Select All" when new data is fetched
        } catch (error) {
            console.error('Error fetching FPS data:', error);
        }
    };


    const handleIndividualCheckboxChange = (godownId) => {
        setGodownData(godownData.map(item =>
            item.godownId === godownId ? { ...item, checked: !item.checked } : item
        ));

        // Update selected rows based on the checkbox
        setSelectedRows(prev =>
            prev.includes(godownId)
                ? prev.filter(id => id !== godownId) // Deselect if already selected
                : [...prev, godownId] // Select if not selected
        );

    };
    // Check if all rows are selected
    useEffect(() => {
        if (godownData.length === 0) {
            // If there's no data, make sure Select All is unchecked
            setSelectAll(false);
        } else if (selectedRows.length === godownData.length) {
            // If all items are selected, check Select All
            setSelectAll(true);
        } else {
            // If not all items are selected, uncheck Select All
            setSelectAll(false);
        }
    }, [selectedRows, godownData.length]); // Re-run when selectedRows or godownData changes


    // console.log('Data:', data);

    const getCurrentDate = () => {
        const today = new Date();
        return format(today, "yyyy-MM-dd"); // Format date as YYYY-MM-DD for the input field
    };
    const capitalizeFirstLetter = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return ''; // Return an empty string if text is undefined or not a string
    };
    const handleClearButtonClick = () => {
        setDistrictId('');  // Reset the districtId state
        setSubDivisionId('');  // Reset the subDivisionId state
        setBlockId('');  // Reset the blockId state
        setPanchayatId('');  // Reset the panchayatId state
        setDistrictUid('');  // Reset the districtId state
        setSubDivisionUid('');  // Reset the subDivisionId state
        setBlockUid('');  // Reset the blockId state
        setPanchayatUid('');
        // setSelectAll(false);
        setInspectionOfficerId('');
        setInspectionOfficers('');
        setDesignationName('');
        setPanchayatUid('');
         setAllocationType('');

        // setSelectAll(false);

    };

    // Handle "Clear" button click
    const handleEarseButtonClick = () => {
        setDistrictId(null);  // Reset the districtId state
        setSubDivisionId(null);  // Reset the subDivisionId state
        setBlockId(null);  // Reset the blockId state
        setPanchayatId(null);  // Reset the panchayatId state
        setGodownData([]); // Clear FPS data
        setSelectAll(false); // Uncheck "Select All"
        setSelectedRows([]); // Deselect all rows
        setDistrictId('');
        setSubDivisionId('');
        setBlockId('');
        setPanchayatId('');
        setDistrictUid('');
        setSubDivisionUid('');
        setBlockUid('');
        setPanchayatUid('');
        setInspectionOfficerId('');
        setInspectionOfficers('');
        setDesignationName('');
        setId('');
        setGodownData([]); // Clear the FPS data table
        setSelectedRows([]); // Deselect any selected rows
        setSelectAll(false); // Uncheck the "Select All" checkbox
         setAllocationType('');

    };
    // Check for valid selection whenever selectedRows or godownData change
    useEffect(() => {
        // Check if there's at least one row selected and the inspection officer is chosen
        const validRows = godownData.some(item =>
            selectedRows.includes(item.godownId) && inspectionOfficerId && item.checked
        );

        setIsValidSelection(validRows); // Enable/Disable button based on the valid selection
    }, [selectedRows, godownData, inspectionOfficerId]); // Run when selectedRows, godownData, or inspectionOfficerId change

    const handleSelectAllChange = (e) => {
        const isChecked = e.target.checked;
        setSelectAll(isChecked);

        // Update the selected rows to include or exclude all FPS IDs
        if (isChecked) {
            // Select all rows and mark their 'checked' property as true
            setSelectedRows(godownData.map(item => item.godownId)); // Select all FPS IDs

            // Update godownData to set checked as true for all rows
            setGodownData(prevData =>
                prevData.map(item => ({
                    ...item,
                    checked: true, // Mark all as checked
                }))
            );
        } else {
            // Deselect all rows and uncheck the 'checked' property
            setSelectedRows([]); // Deselect all

            // Update godownData to set checked as false for all rows
            setGodownData(prevData =>
                prevData.map(item => ({
                    ...item,
                    checked: false, // Uncheck all
                }))
            );
        }


    };

    const handleAllocateButtonClick = async () => {
        const confirmed = window.confirm('Are you sure to Allocate these Inspections');

        // Filter the selected FPS rows where checkbox is selected (regardless of date)
        const selectedData = godownData.filter(item =>
            selectedRows.includes(item.godownId) && item.checked // Ensure checkbox is selected
        ).map(item => {
            const payloadItem = {
                godownId: item.godownId,
                assignedTo: username,
                assignedBy: userInfo.loginUserName,
                designation: designationName, // Optionally add designation if required
                surveyType: allocationType,  // This will be either 'TPDS' or 'CMR'

            };

            // Include dateOfInspection only if it is selected
            if (item.startDate) {
                payloadItem.dateOfInspection = item.startDate;
            }

            return payloadItem;
        });
        // Check for rows where only date is selected (checkbox not selected)
        const rowsWithOnlyDateSelected = inspectionOfficerId !== null; // Only date, checkbox is not checked


        // Check for rows where only checkbox is selected (date not selected)
        const rowsWithOnlyCheckboxSelected = godownData.filter(item =>
            selectedRows.includes(item.godownId) && !inspectionOfficerId && item.checked // Only checkbox, no date
        );

        if (rowsWithOnlyCheckboxSelected.length > 0) {
            alert('Kindly Remove Extra CheckBox');
            return; // Stop further execution if the condition is met
        }

        const sameAssignedByAndTo = selectedData.some(item =>
            item.assignedBy === item.assignedTo &&
            item.designation.trim() !== "District Supply Officer"
        );


        if (sameAssignedByAndTo) {
            alert('Cannot allocate to yourself. Please assign to a different user.');
            setPanchayatId('');
            setPanchayatUid('');
            setInspectionOfficerId('');
            setInspectionOfficers('');
            setDesignationName('');
            setId('');
            setGodownData([]);

            return; // Stop further execution if the condition is met
        }

        if (confirmed) {
            try {
                // Prepare the payload
                const payload = { data: selectedData };

                // Make the API call to the inspectionScheduling/createAll endpoint
                console.log(payload)
                const response = await axios.post(`${godownUrl}/scheduleGodowns`, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    }

                });

                // console.log("API Response:", response.data);
                alert('Allocation successful!');

                // Reset form data after successful allocation
                setDistrictId('');
                setSubDivisionId('');
                setBlockId('');
                setPanchayatId('');
                setDistrictUid('');
                setSubDivisionUid('');
                setBlockUid('');
                setPanchayatUid('');
                setInspectionOfficerId('');
                setInspectionOfficers('');
                setId('');
                setDesignationName('');
                setGodownData([]); // Clear the FPS data table
                setSelectedRows([]); // Deselect any selected rows
                setSelectAll(false); // Uncheck the "Select All" checkbox
                setAllocationType('');

            } catch (error) {
                console.error("Error during allocation:", error);
                alert('Error during allocation. Please try again.');
            }
        } else {
            alert('Allocation canceled!');
        }
    };


    const formatFullName = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text
                .split(' ') // Split the string by spaces into words
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
                .join(' '); // Join the words back into a single string with spaces
        }
        return ''; // Return an empty string if text is undefined or not a string
    };



    const handleEditClick = (godownId) => {
        // Find the FPS data to edit
        const godownToEdit = godownData.find(item => item.godownId === godownId);
        if (!godownToEdit) {
            alert('FPS data not found!');
            return;
        }

        // Prepare the data to send
        const dataToEdit = {
            godownId: godownToEdit.godownId,
            dealerName: godownToEdit.dealerName,
            startDate: godownToEdit.startDate,
            isChecked: selectedRows.includes(godownId), // Check if the checkbox is selected
        };

        // Convert data to a query string
        const queryString = new URLSearchParams(dataToEdit).toString();

        // Open the edit page in a new tab with the data as query parameters
        window.open(`/inspectionEditFps?${queryString}`, '_blank');
    };


    const handleDeleteClick = (godownId) => {
        const confirmed = window.confirm("Are you sure you want to clear the Date and Uncheck this entry?");
        if (!confirmed) return;

        // Clear the startDate and uncheck the checkbox for the specific FPS
        const updatedgodownData = godownData.map(item => {
            if (item.godownId === godownId) {
                return { ...item, startDate: "" }; // Clear the date
            }
            return item;
        });
        setGodownData(updatedgodownData);

        // Uncheck the checkbox
        setSelectedRows(prevSelected => prevSelected.filter(id => id !== godownId));

        // Also update localStorage if needed
        const allocatedData = JSON.parse(localStorage.getItem("allocatedgodownData")) || [];
        const updatedAllocatedData = allocatedData.map(item => {
            if (item.godownId === godownId) {
                return { ...item, dateOfInspection: null, isChecked: false };
            }
            return item;
        });
        localStorage.setItem("allocatedgodownData", JSON.stringify(updatedAllocatedData));
    };



    return (
        <div className="gdAllocation" ref={reportRef}>
            {/* <div className="cmr-pds-button">
                <button
                    className={`custom-button ${allocationType === '1' ? 'active' : ''}`}
                    onClick={() => setAllocationType('1')}
                >
                    CMR
                </button>
                <button
                    className={`custom-button ${allocationType === '2' ? 'active' : ''}`}
                    onClick={() => setAllocationType('2')}
                >
                    TPDS
                </button>

            </div> */}
            <div className="gdAllocation-card">
                <div className="gdAllocation-card-header">CMR Inspection Allocation Form</div>
                <div >
                    <div className="gdAllocation-mainBlock">
                        <div className="gdAllocation-group-cu">
                            <label htmlFor="district" className="textitems"><span className="asterisk">*</span>District</label>
                            {/* Replace select with react-select */}
                            <Select
                                className="search-select"
                                id="district"
                                placeholder="Select a district"
                                value={districts.find((dist) => dist.id === districtId) ? {
                                    value: districts.find((dist) => dist.id === districtId).id,
                                    label: capitalizeFirstLetter(districts.find((dist) => dist.id === districtId).districtName)
                                } : null}
                                onChange={handleDistrictChange}  // Handle the selection change
                                options={districts.sort((a, b) => a.districtName.localeCompare(b.districtName)).map((dist) => ({
                                    value: dist.id,
                                    label: capitalizeFirstLetter(dist.districtName),
                                    districtUid: dist.districtUid
                                }))}
                                isSearchable // Enable search in the dropdown
                                styles={customStyles} // Apply custom styles here
                                required
                                isOpen={isOpen}
                                onMenuOpen={toggleDropdown} // Trigger dropdown open
                                onMenuClose={toggleDropdown} // Trigger dropdown close
                                components={{
                                    DropdownIndicator: () => (
                                        <div onClick={toggleDropdown} style={{ cursor: "pointer", marginRight: "10px" }}>
                                            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange' %3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E" alt="Dropdown" style={{ width: "20px", height: "20px" }} />
                                        </div>
                                    ),
                                }}
                            />
                        </div>
                    
                        <div className="gdAllocation-mainBlock-btn">
                            <div className="gdAllocation-group-cu-testing-2-stock-repo">
                                <button
                                    className="gdAllocation-btn-test-stock-repo" onClick={handleClearButtonClick}
                                    disabled={!districtUid }
                                >
                                    CLEAR
                                </button>
                                <button
                                    className="gdAllocation-btn-test-stock-repo" onClick={handleGetButtonClick}
                                    disabled={!districtUid }
                                >
                                    GET CMR LIST
                                </button>
                            </div>
                        </div>
                      
                    </div>
                   

                </div>

            </div>
            <div className="gdAllocation-card-12">
                <div className="gdAllocation-mainBlock-2T">
                    <div className="gdAllocation-group-cu-2T" >
                        <label htmlFor="fps" className="textitems-1">{/*<span className="asterisk">*</span>*/}Inspection Officer</label>
                        <Select
                            className="search-select"
                            id="inspectionOfficer"
                            placeholder="Select Inspection Officer"
                            value={inspectionOfficerId ? {
                                value: inspectionOfficerId,
                                label: formatFullName(
                                    inspectionOfficers.find((officer) => officer.id === inspectionOfficerId)?.fullname
                                ) + ' - ' + inspectionOfficers.find((officer) => officer.id === inspectionOfficerId)?.username // Concatenate fullname and username
                            } : null}
                            onChange={handleInspectionOfficerChange}
                            options={Array.isArray(inspectionOfficers) ?
                                inspectionOfficers.sort((a, b) => a.fullname.localeCompare(b.fullname)).map((officer) => ({
                                    value: officer.id,
                                    label: `${formatFullName(officer.fullname)} - ${officer.username}`, // Full name - Username format
                                    username: officer.username,
                                    poimsUserId: officer.id,
                                    designation: officer.designation
                                })) : []
                            }

                            isSearchable
                            styles={customStyles}
                            isOpen={isOpen}
                            onMenuOpen={toggleDropdown}
                            onMenuClose={toggleDropdown}
                            components={{
                                DropdownIndicator: () => (
                                    <div onClick={toggleDropdown} style={{ cursor: "pointer", marginRight: "10px" }}>
                                        <img
                                            src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange' %3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E"
                                            alt="Dropdown"
                                            style={{ width: "20px", height: "20px" }}
                                        />
                                    </div>
                                ),
                            }}
                        />
                    </div>
                    <div className="gdAllocation-group-cu-2T" >
                        <label htmlFor="startDate" className="textitems-1"> {/*<span className="asterisk">*</span>*/}  Designation</label>
                        <Select
                            className="search-select"
                            id="designation"
                            placeholder="Select Designation"
                            value={designationName ? {
                                value: designationName,
                                label: formatFullName(
                                    officerDesignation.find((officer) => officer.designation === designationName)?.designation
                                )
                            } : null}
                            onChange={(selectedOption) => setDesignationName(selectedOption ? selectedOption.value : '')}
                            options={Array.isArray(officerDesignation) ?
                                officerDesignation.map((officer) => ({
                                    value: formatFullName(officer.designation),
                                    label: formatFullName(officer.designation),
                                    username: formatFullName(officer.fullname),
                                    poimsUserId: officer.id,
                                    designation: officer.designation
                                })) : []
                            }
                            isSearchable
                            styles={customStyles}
                            // required
                            isOpen={isOpen}
                            onMenuOpen={toggleDropdown}
                            onMenuClose={toggleDropdown}
                            components={{
                                DropdownIndicator: () => (
                                    <div onClick={toggleDropdown} style={{ cursor: "pointer", marginRight: "10px" }}>
                                        <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='orange' %3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E" alt="Dropdown" style={{ width: "20px", height: "20px" }} />
                                    </div>
                                ),
                            }}
                        />
                    </div>
                    {/* <div className="gdAllocation-group-cu">

                    </div> */}

                </div>


            </div>

            {/* Table of FPS Data */}
            <div className="gdAllocation-main-repo">
                <table className="gdAllocation-table-repo">
                    <thead>
                        <tr className="gdAllocation-tr-11">
                            <th rowSpan="2">S.No.</th>
                            <th rowSpan="2">Godown No</th>
                            <th rowSpan="2">Godown Name</th>
                            <th rowSpan="2">Date of Inspection</th>
                            <th rowSpan="2">
                                Select All
                                <input
                                    type="checkbox"
                                    checked={selectAll}
                                    onChange={handleSelectAllChange}
                                />
                            </th>
                            {/* <th style={{visibility: 'hidden'}}>
                                Action
                            </th> */}
                        </tr>
                    </thead>
                    {godownData.length > 0 && (
                        <tbody>
                            {godownData.map((item, index) => (
                                <tr key={index + 1}>
                                    <td>{index + 1}</td>
                                    <td>{item.godownId}</td>
                                    <td>{formatFullName(item.godownName)}</td>
                                    <td>
                                        <input
                                            type="date"
                                            value={item.startDate} // Bind to the respective item startDate
                                            onChange={(e) => handleStartDateChange(e, item.godownId)}
                                            min={formattedStartOfYear}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={selectedRows.includes(item.godownId)}
                                            onChange={() => handleIndividualCheckboxChange(item.godownId)}
                                        />
                                    </td>
                                    {/* <td >
                                        <button
                                            className="editbutton-2"
                                            onClick={() => handleEditClick(item.godownId)}
                                            disabled={!item.checked } // Disabled if checkbox is unchecked or date is empty
                                        >
                                            Edit
                                        </button>
                                        <button
                                            className="deleteButton-2"
                                            onClick={() => handleDeleteClick(item.godownId)}
                                            disabled={!item.checked } // Same condition here
                                        >
                                            Delete
                                        </button>
                                    </td> */}

                                </tr>
                            ))}
                        </tbody>
                    )}
                </table>

                <div className="belowButtons" >
                <button
                        className="gdAllocation-button"
                        onClick={handleEarseButtonClick}
                        disabled={!isValidSelection} // Disable if no data
                        // disabled="true"
                    >

                        CLEAR
                    </button>
                    <button
                        className="gdAllocation-button"
                        onClick={handleAllocateButtonClick}
                        disabled={!isValidSelection} // Disable if no data
                        // disabled="true"
                    >
                        ALLOCATE
                    </button>
                </div>

            </div>
        </div>
    );
}
export default CMRRoasterEntry;